import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSitemap } from "@fortawesome/free-solid-svg-icons";
import * as style from "./styles.module.scss";
import CandidateProgressModal from "../../common/CandidateProgressModal";

const OnboardImage = ({
  title,
  subtitle,
  desktopDescription,
  mobileDescription,
  imagePath,
  className,
  imageClassName,
  buttonUnderText = false,
  innerProgressShow = false,
  innerProgressCurrentStep = 1,
  innerProgressTotalSteps = 1,
  innerProgressTitle = "Registration",
  additionalDescription = "",
  currentJobProgressState,
}) => {
  const progress = (innerProgressCurrentStep / innerProgressTotalSteps) * 100;
  const [progressMapOpen, setProgressMapOpen] = useState(false);
  return (
    <>
      {progressMapOpen && (
        <CandidateProgressModal
          setProgressMapOpen={setProgressMapOpen}
          progressState={currentJobProgressState}
        />
      )}
      <div className={`col-sm-12 col-lg-6 ${className || ""}`}>
        <div
          className={`${style.onboardImage__imageText} ${
            title.includes("Well done") ? style.onboardImage__well_done : ""
          } mt-lg-4 mr-lg-5 mr-0 mb-3`}
        >
          {innerProgressShow && (
            <div className={"pb-2"}>
              <div
                className={"d-flex align-items-center justify-content-between"}
              >
                <p>
                  {innerProgressTitle} (step {innerProgressCurrentStep}/
                  {innerProgressTotalSteps})
                </p>
                {currentJobProgressState && (
                  <div className="ml-2">
                    <button
                      onClick={() => setProgressMapOpen(true)}
                      className={style.onboardImage__openProgressMapBtn}
                    >
                      <FontAwesomeIcon icon={faSitemap} />
                      <span
                        style={{
                          marginLeft: "5px",
                          textDecoration: "underline",
                        }}
                      >
                        {" "}
                        Progress map
                      </span>
                    </button>
                  </div>
                )}
              </div>
              <div
                className={`${style.onboardImage__progressBar}`}
                style={{ width: "100%" }}
              >
                <div
                  className={style.onboardImage__progressBarFill}
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          )}

          <h2>
            {title}&nbsp;
            <br className="d-none d-lg-block" />
          </h2>
          <h3>{subtitle}</h3>
          <p className="d-xl-none d-lg-none">{mobileDescription}</p>
          <p className="d-none d-sm-none d-lg-block d-xl-block">
            {desktopDescription}
          </p>
          {additionalDescription && <p>{additionalDescription}</p>}
          {buttonUnderText && (
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Link
                to="/profile"
                style={{ width: "290px" }}
                className="btn btn-primary btn-block m-auto"
              >
                Take me to my profile
              </Link>
            </div>
          )}
          <img
            className={` d-none d-lg-block ${imageClassName || ""}`}
            src={imagePath}
          />
        </div>
      </div>
    </>
  );
};

export default OnboardImage;
